import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppSidebarUserComponent } from '../../shared/components/app-sidebar-user/app-sidebar-user.component';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { MaintenanceNoticeService } from './maintenance-notice.service';

@Component({
  selector: 'app-maintenance-lockdown',
  imports: [LoadingSpinnerComponent, AppSidebarUserComponent],
  templateUrl: './maintenance-lockdown.component.html',
  styleUrl: './maintenance-lockdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceLockdownComponent {
  protected readonly maintenanceNotice = inject(MaintenanceNoticeService);
}
